import React, { Component } from 'react';
import classNameBind from 'classnames/bind';
import truncate from 'lodash/truncate';
import { withTranslation } from '../../../Translator';
import { formatPercent } from '../../methods/formatData';
import styles from './PieLabel.module.css';
import {
  DEG_TO_RAD_CONVERTER,
  endAngle,
  startAngle,
  getPieLabelPosition,
  isLabelHidden,
} from '../../pieHelpers';

const bindClasses = classNameBind.bind(styles);
const ANGLE_HALF_POINT = (startAngle + endAngle) / 2;

class PieLabel extends Component {
  constructor() {
    super();
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.watchMargin();
  }

  componentDidUpdate() {
    this.watchMargin();
  }

  isOnRightSide() {
    const { midAngle } = this.props;

    return midAngle > ANGLE_HALF_POINT;
  }

  watchMargin() {
    const { setMargins, midAngle, outerRadius } = this.props;

    if (this.ref.current) {
      const width = this.ref.current.getComputedTextLength();
      const onRightSide = this.isOnRightSide();
      const margin = Math.ceil(
        width + Math.abs(Math.cos(midAngle * DEG_TO_RAD_CONVERTER)) * outerRadius - outerRadius,
      );

      if (onRightSide) {
        setMargins(0, margin);
      } else {
        setMargins(margin, 0);
      }
    }
  }

  render() {
    const { cx, cy, midAngle, outerRadius, percent, name, threshold, t, fill } = this.props;

    if (isLabelHidden(percent, threshold)) {
      return null;
    }

    const { x, y } = getPieLabelPosition({
      cx,
      cy,
      midAngle,
      outerRadius,
    });
    const onRightSide = this.isOnRightSide();

    return (
      <text
        ref={this.ref}
        x={x + (onRightSide ? 1 : -1)}
        y={y}
        fill="#000"
        textAnchor={onRightSide ? 'start' : 'end'}
        dominantBaseline="central"
        className={bindClasses('label')}
        data-ppuc-id="Chart.PieLabel"
      >
        <tspan style={{ fill }}>&#x25CF; </tspan>
        <tspan className={bindClasses('bold')}>{`${truncate(name, { length: 24 })}`}</tspan>
        <tspan>{` (${formatPercent(percent, t)})`}</tspan>
      </text>
    );
  }
}

export default withTranslation('components')(PieLabel);
